module.exports = __webpack_public_path__ + "media/images/img-hobby-1-5a842029.jpg";